
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorDeBultos } from '@/views/a-control-bultos/controlador';
    import controlbultos from './control-bultos/control-bultos-inicio.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            controlbultos
        }
    } )
    export default class Componente extends Vue
    {
        public Controlador: ControladorDeBultos = null;
        public get Modo() { return this.Controlador.Vista.Modo; }
        public set Modo( x: string ) { this.Controlador.Vista.Modo = x; }

        created()
        {
            this.Controlador = new ControladorDeBultos();
            this.Controlador.Vista.Modo = 'menu';
        }
    }
